import React from 'react';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';

const LandingPage = () => {
  const handleBuyClick = () => {
    const salesPlatformUrl = process.env.REACT_APP_SALES_PLATFORM_URL || 'https://sua-plataforma-de-vendas.com';
    window.open(salesPlatformUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header - Estilo Russell Brunson */}
      <header className="bg-slate-100 py-4 px-4 border-b border-slate-200">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center">
            {/* Logo profissional no canto esquerdo */}
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-xl shadow-lg">
              <div className="flex items-center justify-center w-8 h-8 bg-white rounded-full">
                <span className="text-xl">🌙</span>
              </div>
              <div className="text-left">
                <div className="text-sm font-black tracking-tight leading-none">DESAFIO</div>
                <div className="text-base font-bold tracking-wider leading-none">7 DIAS</div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section - Estilo Russell Brunson */}
      <section className="py-12 px-4">
        <div className="container mx-auto max-w-4xl text-center">

          {/* Main Headline */}
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black text-slate-900 leading-tight mb-4 md:mb-6 px-2">
            "Me Dê Apenas 7 Dias E Vou Te Mostrar O Método Exato
            <span className="text-red-600"> Passo a Passo</span> Para Acabar Com Sua Insônia De Uma Vez Por Todas!"
          </h1>

          {/* Sub-headline */}
          <h2 className="text-xl sm:text-2xl md:text-3xl text-slate-700 font-bold mb-6 md:mb-8 px-2">
            Como Acabar Com a Insônia em 7 Dias
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-slate-600 mb-6 md:mb-8 max-w-3xl mx-auto px-4">
            Digite seu melhor email abaixo para ter acesso a este ebook por apenas <span className="font-bold text-red-600">R$ 49,99</span>:
          </p>

          {/* Arrow Image Placeholder */}
          <div className="mb-8">
            <svg className="w-24 h-24 mx-auto text-red-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
          </div>

          {/* CTA Button - Estilo Russell */}
          <div className="max-w-xl mx-auto px-4">
            <Button 
              onClick={handleBuyClick}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold text-base sm:text-lg md:text-xl lg:text-2xl py-6 sm:py-7 md:py-8 px-6 sm:px-8 md:px-12 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 mb-4"
            >
              QUERO ACABAR COM MINHA INSÔNIA AGORA!
            </Button>
            <p className="text-xs sm:text-sm text-slate-500">
              Acesso instantâneo • Pagamento 100% seguro
            </p>
          </div>
        </div>
      </section>

      {/* Main Image */}
      <section className="py-8 md:py-12 px-4 bg-slate-50">
        <div className="container mx-auto max-w-4xl">
          <img 
            src="https://images.unsplash.com/photo-1688382575775-9aaa5025524e?w=1000&q=80" 
            alt="Pessoa dormindo tranquilamente"
            className="rounded-xl md:rounded-2xl shadow-2xl w-full h-[250px] sm:h-[300px] md:h-[400px] object-cover"
          />
        </div>
      </section>

      {/* Question Section */}
      <section className="py-12 md:py-20 px-4 bg-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-4 md:mb-6 px-2">
            O Que Você Faria Se Pudesse
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-red-600 mb-6 md:mb-8 px-2">
            Dormir 8 Horas Seguidas
          </h3>
          <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-8 md:mb-12 px-2">
            TODAS AS NOITES!?!
          </h3>

          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-slate-700 mb-8 md:mb-12 leading-relaxed max-w-3xl mx-auto px-4">
            Este <span className="font-bold">Método Passo a Passo</span> vai te mostrar nos bastidores as estratégias exatas que você precisa para finalmente vencer a insônia e ter noites tranquilas!
          </p>

          {/* Arrow */}
          <div className="mb-8">
            <svg className="w-24 h-24 mx-auto text-red-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
          </div>

          <Button 
            onClick={handleBuyClick}
            className="bg-green-600 hover:bg-green-700 text-white font-bold text-base sm:text-lg md:text-xl lg:text-2xl py-6 sm:py-7 md:py-8 px-8 sm:px-12 md:px-16 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 mx-4"
          >
            COMPRAR AGORA POR R$ 49,99
          </Button>
        </div>
      </section>

      {/* 7 Day Method Section */}
      <section className="py-20 px-4 bg-slate-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12 md:mb-16 px-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-4 md:mb-6">
              O Método de 7 Dias
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-slate-600 max-w-2xl mx-auto">
              Cada dia você terá uma missão simples. Siga o passo a passo e veja sua vida transformar!
            </p>
          </div>

          {/* Day Cards */}
          <div className="space-y-8 max-w-4xl mx-auto">
            {/* Day 1 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-red-600">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-red-600 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    1
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Dê à Sua Mente o Sinal de Que É Hora de Parar
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Você vai aprender a identificar a mente hiperativa e mudar completamente sua associação com a hora de dormir. É o dia mais importante do método!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 2 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-orange-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-orange-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    2
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Seu Sono Começa Quando Você Acorda
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Descubra como seus hábitos durante o dia estão DESTRUINDO seu sono à noite. Você vai aprender o que ajustar para dormir como um bebê!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 3 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-yellow-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-yellow-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    3
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Corte o Que Te Sabota Sem Perceber
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Identifique os sabotadores INVISÍVEIS que estão mantendo você acordada. Quando você eliminar isso, vai dormir em 30 minutos ou menos!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 4 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-green-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-green-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    4
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Ganhe da Ansiedade com Escrita, Não com Força
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    A técnica secreta de escrita terapêutica que vai esvaziar sua mente em 10 minutos. Funciona TODA vez!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 5 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-blue-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-blue-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    5
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Mexa o Corpo para Silenciar a Mente
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Relaxamento muscular progressivo que silencia sua mente através do corpo. Super simples e incrivelmente eficaz!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 6 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-indigo-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-indigo-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    6
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Enfrente o Medo da Noite Antes que Ele Vença Você
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Reprograme o medo condicionado da noite. Você vai aprender a AMAR a hora de dormir novamente!
                  </p>
                </div>
              </div>
            </div>

            {/* Day 7 */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 border-l-8 border-purple-500">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-6">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-purple-500 rounded-full flex items-center justify-center text-white font-black text-xl sm:text-2xl md:text-3xl">
                    7
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-black text-slate-900 mb-2 md:mb-3">
                    Programe Sua Nova Rotina e Não Volte Atrás
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-slate-600">
                    Consolide tudo o que aprendeu em uma rotina simples que você vai seguir para o resto da vida. Insônia? NUNCA MAIS!
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="mt-8 md:mt-12 text-center px-4">
            <svg className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto text-red-600 mb-6 md:mb-8" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>

            <Button 
              onClick={handleBuyClick}
              className="bg-green-600 hover:bg-green-700 text-white font-bold text-base sm:text-lg md:text-xl lg:text-2xl py-6 sm:py-7 md:py-8 px-8 sm:px-12 md:px-16 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 w-full sm:w-auto"
            >
              COMPRAR O MÉTODO COMPLETO AGORA!
            </Button>
          </div>
        </div>
      </section>

      {/* Bonus Section */}
      <section className="py-12 md:py-20 px-4 bg-yellow-50 border-t-4 md:border-t-8 border-yellow-400">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-slate-900 mb-6 md:mb-8">
            *** BÔNUS ESPECIAIS ***
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-slate-700 font-bold mb-8 md:mb-12 px-2">
            Quando Você Comprar Hoje, Você Também Recebe:
          </p>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12">
            {/* Bonus 1 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
              <div className="bg-red-600 text-white px-3 py-1.5 md:px-4 md:py-2 rounded-full inline-block font-bold text-sm md:text-base mb-3 md:mb-4">
                BÔNUS #1
              </div>
              <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-3 md:mb-4">
                Modelo Diário do Sono
              </h3>
              <p className="text-base md:text-lg text-slate-600">
                Acompanhe sua evolução dia a dia e identifique exatamente o que funciona para VOCÊ!
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
              <div className="bg-red-600 text-white px-3 py-1.5 md:px-4 md:py-2 rounded-full inline-block font-bold text-sm md:text-base mb-3 md:mb-4">
                BÔNUS #2
              </div>
              <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-3 md:mb-4">
                Checklist do Sono
              </h3>
              <p className="text-base md:text-lg text-slate-600">
                Os 10 pilares essenciais que você DEVE verificar todas as noites para garantir seu sono perfeito!
              </p>
            </div>
          </div>

          <div className="mb-6 md:mb-8">
            <svg className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto text-red-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a1 1 0 011 1v10.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
          </div>

          <Button 
            onClick={handleBuyClick}
            className="bg-green-600 hover:bg-green-700 text-white font-bold text-base sm:text-lg md:text-xl lg:text-2xl py-6 sm:py-7 md:py-8 px-8 sm:px-12 md:px-16 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 w-full sm:w-auto"
          >
            SIM! QUERO TUDO ISSO POR R$ 49,99
          </Button>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 md:py-20 px-4 bg-slate-900 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 md:mb-6 px-2">
            "Me Dê Apenas 7 Dias...
          </h2>
          <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-8 md:mb-12 px-2">
            E Vou Te Mostrar Como Acabar Com Sua Insônia Para Sempre!"
          </h3>

          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-6 md:p-12 mb-8 md:mb-12">
            <p className="text-base sm:text-lg md:text-xl leading-relaxed mb-6 md:mb-8 px-2">
              Digite seu email abaixo para ter acesso instantâneo ao método completo de 7 dias + os 2 bônus especiais que vão te ajudar a dormir profundamente TODAS AS NOITES!
            </p>

            <div className="space-y-3 md:space-y-4 text-left max-w-2xl mx-auto mb-6 md:mb-8 px-4">
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg">Ebook "Como Acabar com a Insônia em 7 Dias" (completo)</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg">Método passo a passo com 7 missões diárias (15-30 min/dia)</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg">Técnicas práticas: Respiração 4-7-8, escrita terapêutica, relaxamento muscular</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg"><strong>BÔNUS:</strong> Modelo Diário do Sono (PDF imprimível)</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg"><strong>BÔNUS:</strong> Checklist do Sono com 10 pilares essenciais</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-400 flex-shrink-0" />
                <span className="text-sm sm:text-base md:text-lg">Acesso vitalício a todo o material digital</span>
              </div>
            </div>

            <div className="bg-yellow-400 text-slate-900 rounded-lg p-4 md:p-6 mb-6 md:mb-8">
              <p className="text-2xl sm:text-3xl md:text-3xl font-black mb-1 md:mb-2">APENAS R$ 49,99</p>
              <p className="text-sm sm:text-base md:text-lg font-bold">Pagamento único • Acesso instantâneo</p>
            </div>

            <Button 
              onClick={handleBuyClick}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-black text-base sm:text-lg md:text-xl lg:text-2xl py-6 sm:py-8 md:py-10 px-6 sm:px-12 md:px-16 rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 animate-pulse"
            >
              COMPRAR AGORA E ACABAR COM MINHA INSÔNIA!
            </Button>

            <p className="text-xs sm:text-sm mt-4 md:mt-6 text-white/80">
              🔒 Pagamento 100% seguro • Acesso IMEDIATO por email
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-8 px-4">
        <div className="container mx-auto max-w-6xl text-center">
          <p className="mb-4">© 2025 Como Acabar com a Insônia em 7 Dias - Flavia Silveira</p>
          <p className="text-sm">Todos os direitos reservados. Este produto é um material digital (ebook em PDF).</p>
          <div className="mt-4 space-x-4 text-sm">
            <a href="#" className="hover:text-white">Termos de Uso</a>
            <span>•</span>
            <a href="#" className="hover:text-white">Política de Privacidade</a>
            <span>•</span>
            <a href="#" className="hover:text-white">Contato</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;